import React from 'react';
import { Button, Modal, ConfigProvider } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { logEvent } from '../../analytics'
import deleteSession from '../../utils/session/deleteSession'

export default function RecordingDiscard({
                                           recordingModalState,
                                           sessionUuid,
                                           endRecording,
                                           onDiscarded,
                                         }) {
  const { t } = useTranslation()

  const handleClick = () => {
    // No session: just close immediately
    if (recordingModalState === 'initial' || !sessionUuid) {
      onDiscarded()
      return
    }

    logEvent('RecordingModal', 'DiscardOpen')

    Modal.confirm({
      title: t('note_type_selector.confirm_title'),
      content: t('note_type_selector.confirm_context'),
      okText: t('note_type_selector.confirm_ok_text'),
      okType: 'danger',
      cancelText: t('note_type_selector.confirm_no_text'),
      onOk: async () => {
        try {
          const success = await deleteSession(sessionUuid)
          logEvent('SessionRecorder', 'DiscardConfirm')

          await endRecording() // Always stop recording, regardless of success

          if (success) {
            Modal.destroyAll()
            onDiscarded()
          } else {
            console.warn('Failed to delete session')
          }
        } catch (err) {
          console.error('Error during session discard:', err)
        }
      },
    })
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            colorError: 'grey',
          },
        },
      }}
    >
      <Button
        icon={<CloseOutlined />}
        shape="circle"
        danger
        onClick={handleClick}
        style={{ position: 'absolute', top: 10, right: 10 }}
      />
    </ConfigProvider>
  )
}